import MainCardBodyContainer from './MainCardBodyContainer';

export default MainCardBodyContainer;
